module.exports = __webpack_public_path__ + "media/icons/key-2-b975f9f0.svg";